import { render, staticRenderFns } from "./CollapseCard.vue?vue&type=template&id=643abc8e&lang=pug&"
import script from "./CollapseCard.vue?vue&type=script&lang=js&"
export * from "./CollapseCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports